export enum kyc_status {
  NOT_STARTED = "NOT_STARTED",
  CREATED = "CREATED",
  PROCESSING = "PROCESSING",
  ABORTED = "ABORTED",
  PENDING_REVIEW = "PENDING_REVIEW",
  VALIDATED = "VALIDATED",
  DECLINED = "DECLINED",
}
